

































































































































import Vue from 'vue'
import SeismicForm from '@/models/SeismicForm'
import PointsParticuliers from '@/components/SeismicInsepctionForm/_PointsParticuliers.vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'InspectionCriteria2',
  components: {
    PointsParticuliers
  },
  props: {
    form: { type: [SeismicForm, Object] }
  },
  computed: {
    ...mapGetters(['getIsPrintablePDFMode'])
  },
  data () {
    return {
      specificPoints: [] as Array<string>
    }
  },
  beforeDestroy () {
    this.$emit('saveForm', this.form)
  },
  methods: {

  }
})

